export const entrySurfaceCopy = {
  en: {
    connectionFailed: 'Connection was not completed',
    connectionChecking: 'Checking your connection',
    connectionFailedBody:
      'The provider could not complete authorization. Return to your original Poneva window for details and a retry.',
    connectionCheckingBody:
      'Your original Poneva window is checking whether the account was connected. You can close this window.',
    goConnections: 'Go to Connections',
    choosePlatform: 'Choose a download platform',
    forMac: 'For your Mac',
    forPc: 'For your PC',
    includingNix: 'Including NixOS',
    verify: 'Verify this download',
    checksumHelp:
      'Compare the file’s checksum with the signed checksums and verify the signature using Poneva’s public key.',
    signedChecksums: 'Signed checksums',
    signature: 'Signature',
    publicKey: 'Public key',
    fingerprint: 'Public key fingerprint (SHA-256):',
    downloads: 'Downloads',
    checkingDownloads: 'Checking available downloads…',
    unavailable: 'Downloads are temporarily unavailable. Try again later.',
    notPublished: 'Desktop downloads are not published yet.',
    webReady:
      'When a signed release is available, its download will appear here. Your web workspace is ready to use now.',
    forDevice: 'For this device',
    chooseMac: 'Choose Apple silicon or Intel to match your Mac.',
    installersUnavailable:
      'Installers are not published yet. Available downloads will appear here.',
    nixNote: 'NixOS package instructions will appear when the source package is published.',
    workspaceNote:
      'The desktop app connects to this Poneva workspace; it does not create a separate account or copy your chats.',
    checksum: 'Checksum',
    copied: 'Copied',
    copyChecksum: 'Copy checksum',
    download: 'Download',
    installer: 'installer',
    invitationLink: 'Invitation link',
    googlePendingTitle: 'Continue in your browser',
    googlePendingLead:
      'Finish signing in with Google in your browser, then choose Open Poneva Chat to return here.',
    googlePendingWaiting: 'Waiting for sign-in…',
    googlePendingNote: 'Keep this window open while you sign in.',
    desktopDescription:
      'Use Poneva in a desktop window with the same account, chats and company workspace as the web app.',
    detectedPlatformHint: 'Detected {platform}. You can also download for another computer.',
    choosePlatformHint: 'Choose the platform for the computer where you want to use Poneva.',
    downloadFor: 'Download for {arch}',
    downloadFormat: 'Download {format}',
    dmgInstaller: 'DMG installer',
    nixUpdateInstruction:
      'For a newer release, replace the input URL with its new source URL, then update your lock file:',
    sourceVersion: 'Source v{version} · SHA-256:',
    nixUnpublished: 'NixOS package instructions will appear when the source package is published.',
    platformDownloads: '{platform} downloads',
    ponevaFor: 'Poneva for {platform}',
  },
  bg: {
    connectionFailed: 'Връзката не беше завършена',
    connectionChecking: 'Проверка на връзката',
    connectionFailedBody:
      'Доставчикът не успя да завърши упълномощаването. Върнете се в първоначалния прозорец на Poneva за подробности и нов опит.',
    connectionCheckingBody:
      'Първоначалният прозорец на Poneva проверява дали акаунтът е свързан. Можете да затворите този прозорец.',
    goConnections: 'Към връзките',
    choosePlatform: 'Изберете платформа за изтегляне',
    forMac: 'За вашия Mac',
    forPc: 'За вашия PC',
    includingNix: 'Включително NixOS',
    verify: 'Провери това изтегляне',
    checksumHelp:
      'Сравнете контролната сума на файла с подписаните контролни суми и проверете подписа с публичния ключ на Poneva.',
    signedChecksums: 'Подписани контролни суми',
    signature: 'Подпис',
    publicKey: 'Публичен ключ',
    fingerprint: 'Пръстов отпечатък на публичния ключ (SHA-256):',
    downloads: 'Изтегляния',
    checkingDownloads: 'Проверка на наличните изтегляния…',
    unavailable: 'Изтеглянията временно не са налични. Опитайте отново.',
    notPublished: 'Изтеглянията за настолен компютър още не са публикувани.',
    webReady:
      'Когато има налична подписана версия, изтеглянето ѝ ще се появи тук. Уеб работното ви пространство е готово за използване още сега.',
    forDevice: 'За това устройство',
    chooseMac: 'Изберете Apple silicon или Intel според вашия Mac.',
    installersUnavailable:
      'Инсталаторите все още не са публикувани. Наличните изтегляния ще се появят тук.',
    nixNote:
      'Инструкциите за пакета за NixOS ще се появят, когато изходният пакет бъде публикуван.',
    workspaceNote:
      'Настолното приложение се свързва с това работно пространство на Poneva; то не създава отделен акаунт и не копира чатовете ви.',
    checksum: 'Контролна сума',
    copied: 'Копирано',
    copyChecksum: 'Копирай контролната сума',
    download: 'Изтегляне',
    installer: 'инсталатор',
    invitationLink: 'Към връзките',
    googlePendingTitle: 'Продължете в браузъра си',
    googlePendingLead:
      'Завършете влизането с Google в браузъра си, след което изберете „Отваряне на Poneva Chat“, за да се върнете тук.',
    googlePendingWaiting: 'Изчакване на влизането…',
    googlePendingNote: 'Оставете този прозорец отворен, докато влизате.',
    desktopDescription:
      'Използвайте Poneva в прозорец на компютъра със същия акаунт, чатове и фирмено работно пространство като в уеб приложението.',
    detectedPlatformHint:
      'Открита платформа: {platform}. Можете да изтеглите приложението и за друг компютър.',
    choosePlatformHint: 'Изберете платформата на компютъра, на който искате да използвате Poneva.',
    downloadFor: 'Изтегляне за {arch}',
    downloadFormat: 'Изтегляне на {format}',
    dmgInstaller: 'Инсталатор за DMG',
    nixUpdateInstruction:
      'За по-нова версия заменете URL адреса за вход с новия URL адрес на източника, след което актуализирайте lock файла:',
    sourceVersion: 'Версия на източника v{version} · SHA-256:',
    nixUnpublished:
      'Инструкциите за пакета за NixOS ще се покажат, когато пакетът от източника бъде публикуван.',
    platformDownloads: 'Изтегляния за {platform}',
    ponevaFor: 'Poneva за {platform}',
  },
  cs: {
    connectionFailed: 'Připojení nebylo dokončeno',
    connectionChecking: 'Kontrola připojení',
    connectionFailedBody:
      'Poskytovateli se nepodařilo dokončit autorizaci. Vraťte se do původního okna Poneva, kde najdete podrobnosti a možnost opakování.',
    connectionCheckingBody:
      'V původním okně Poneva se ověřuje, zda byl účet připojen. Toto okno můžete zavřít.',
    goConnections: 'Přejít na připojení',
    choosePlatform: 'Vyberte platformu ke stažení',
    forMac: 'Pro váš Mac',
    forPc: 'Pro váš počítač',
    includingNix: 'Včetně NixOS',
    verify: 'Ověřit toto stažení',
    checksumHelp:
      'Porovnejte kontrolní součet souboru s podepsanými kontrolními součty a ověřte podpis pomocí veřejného klíče Poneva.',
    signedChecksums: 'Podepsané kontrolní součty',
    signature: 'Podpis',
    publicKey: 'Veřejný klíč',
    fingerprint: 'Otisk veřejného klíče (SHA-256):',
    downloads: 'Stažení',
    checkingDownloads: 'Kontroluji dostupná stažení…',
    unavailable: 'Stažení je dočasně nedostupné. Zkuste to znovu.',
    notPublished: 'Stažení pro počítač zatím nejsou zveřejněna.',
    webReady:
      'Až bude k dispozici podepsaná verze, zobrazí se zde její stažení. Váš webový pracovní prostor je nyní připraven k použití.',
    forDevice: 'Pro toto zařízení',
    chooseMac: 'Vyberte Apple silicon nebo Intel podle svého Macu.',
    installersUnavailable:
      'Instalační programy zatím nebyly zveřejněny. Dostupné soubory ke stažení se zobrazí zde.',
    nixNote: 'Pokyny k instalaci balíčku pro NixOS se zobrazí po zveřejnění zdrojového balíčku.',
    workspaceNote:
      'Desktopová aplikace se připojuje k tomuto pracovnímu prostoru Poneva; nevytváří samostatný účet ani nekopíruje vaše chaty.',
    checksum: 'Kontrolní součet',
    copied: 'Zkopírováno',
    copyChecksum: 'Kopírovat kontrolní součet',
    download: 'Stáhnout',
    installer: 'instalační program',
    invitationLink: 'Přejít na připojení',
    googlePendingTitle: 'Pokračujte v prohlížeči',
    googlePendingLead:
      'Dokončete přihlášení přes Google v prohlížeči a pak zvolte Otevřít Poneva Chat, abyste se vrátili sem.',
    googlePendingWaiting: 'Čeká se na přihlášení…',
    googlePendingNote: 'Během přihlašování nechte toto okno otevřené.',
    desktopDescription:
      'Používejte Poneva v okně desktopové aplikace se stejným účtem, chaty a firemním pracovním prostorem jako ve webové aplikaci.',
    detectedPlatformHint:
      'Zjištěna platforma {platform}. Můžete také stáhnout verzi pro jiný počítač.',
    choosePlatformHint: 'Vyberte platformu počítače, na kterém chcete Poneva používat.',
    downloadFor: 'Stáhnout pro {arch}',
    downloadFormat: 'Stáhnout {format}',
    dmgInstaller: 'Instalační program DMG',
    nixUpdateInstruction:
      'Chcete-li získat novější verzi, nahraďte vstupní URL novou zdrojovou URL a poté aktualizujte zamykací soubor:',
    sourceVersion: 'Zdrojová verze v{version} · SHA-256:',
    nixUnpublished:
      'Pokyny k balíčku pro NixOS se zobrazí, jakmile bude zdrojový balíček publikován.',
    platformDownloads: 'Stažení pro platformu {platform}',
    ponevaFor: 'Poneva pro {platform}',
  },
  da: {
    connectionFailed: 'Forbindelsen blev ikke fuldført',
    connectionChecking: 'Forbindelsen kontrolleres',
    connectionFailedBody:
      'Udbyderen kunne ikke gennemføre godkendelsen. Gå tilbage til dit oprindelige Poneva-vindue for at se oplysningerne og prøve igen.',
    connectionCheckingBody:
      'Dit oprindelige Poneva-vindue kontrollerer, om kontoen blev tilsluttet. Du kan lukke dette vindue.',
    goConnections: 'Gå til forbindelser',
    choosePlatform: 'Vælg en downloadplatform',
    forMac: 'Til din Mac',
    forPc: 'Til din pc',
    includingNix: 'Inklusive NixOS',
    verify: 'Bekræft denne download',
    checksumHelp:
      'Sammenlign filens kontrolsum med de signerede kontrolsummer, og bekræft signaturen ved hjælp af Ponevas offentlige nøgle.',
    signedChecksums: 'Signerede kontrolsummer',
    signature: 'Signatur',
    publicKey: 'Offentlig nøgle',
    fingerprint: 'Fingeraftryk for offentlig nøgle (SHA-256):',
    downloads: 'Overførsler',
    checkingDownloads: 'Tjekker tilgængelige downloads…',
    unavailable: 'Downloads er midlertidigt utilgængelige. Prøv igen senere.',
    notPublished: 'Desktopdownloads er endnu ikke udgivet.',
    webReady:
      'Når en signeret version er tilgængelig, vises overførslen her. Dit webarbejdsområde er klar til brug nu.',
    forDevice: 'Til denne enhed',
    chooseMac: 'Vælg Apple Silicon eller Intel, så det passer til din Mac.',
    installersUnavailable:
      'Installationsprogrammer er endnu ikke udgivet. Tilgængelige downloads vises her.',
    nixNote: 'Instruktioner til NixOS-pakken vises, når kildekoden til pakken er udgivet.',
    workspaceNote:
      'Skrivebordsappen opretter forbindelse til dette Poneva-arbejdsområde. Den opretter ikke en separat konto og kopierer ikke dine chats.',
    checksum: 'Kontrolsum',
    copied: 'Kopieret',
    copyChecksum: 'Kopiér kontrolsum',
    download: 'Hent',
    installer: 'installationsprogram',
    invitationLink: 'Gå til forbindelser',
    googlePendingTitle: 'Fortsæt i din browser',
    googlePendingLead:
      'Gennemfør login med Google i din browser, og vælg derefter Åbn Poneva Chat for at vende tilbage hertil.',
    googlePendingWaiting: 'Venter på login…',
    googlePendingNote: 'Hold dette vindue åbent, mens du logger ind.',
    desktopDescription:
      'Brug Poneva i et skrivebordsvindue med samme konto, chats og virksomhedsarbejdsområde som webappen.',
    detectedPlatformHint: 'Registrerede {platform}. Du kan også downloade til en anden computer.',
    choosePlatformHint: 'Vælg den platform, der bruges på den computer, hvor du vil bruge Poneva.',
    downloadFor: 'Download til {arch}',
    downloadFormat: 'Download {format}',
    dmgInstaller: 'DMG-installationsprogram',
    nixUpdateInstruction:
      "Hvis du vil have en nyere version, skal du erstatte input-URL'en med den nye kilde-URL og derefter opdatere din låsefil:",
    sourceVersion: 'Kilde v{version} · SHA-256:',
    nixUnpublished: 'NixOS-pakkeinstruktioner vises, når kildepakken er udgivet.',
    platformDownloads: '{platform}-downloads',
    ponevaFor: 'Poneva til {platform}',
  },
  de: {
    connectionFailed: 'Verbindung wurde nicht abgeschlossen',
    connectionChecking: 'Verbindung wird geprüft',
    connectionFailedBody:
      'Der Anbieter konnte die Autorisierung nicht abschließen. Kehren Sie zu Ihrem ursprünglichen Poneva-Fenster zurück, um Details zu sehen und es erneut zu versuchen.',
    connectionCheckingBody:
      'Ihr ursprüngliches Poneva-Fenster prüft, ob das Konto verbunden wurde. Sie können dieses Fenster schließen.',
    goConnections: 'Zu den Verbindungen',
    choosePlatform: 'Downloadplattform auswählen',
    forMac: 'Für Ihren Mac',
    forPc: 'Für Ihren PC',
    includingNix: 'Einschließlich NixOS',
    verify: 'Diesen Download überprüfen',
    checksumHelp:
      'Vergleichen Sie die Prüfsumme der Datei mit den signierten Prüfsummen und überprüfen Sie die Signatur mit Ponevas öffentlichem Schlüssel.',
    signedChecksums: 'Signierte Prüfsummen',
    signature: 'Signatur',
    publicKey: 'Öffentlicher Schlüssel',
    fingerprint: 'Fingerabdruck des öffentlichen Schlüssels (SHA-256):',
    downloads: 'Downloads',
    checkingDownloads: 'Verfügbare Downloads werden geprüft…',
    unavailable: 'Downloads sind vorübergehend nicht verfügbar. Versuchen Sie es später erneut.',
    notPublished: 'Desktopdownloads sind noch nicht veröffentlicht.',
    webReady:
      'Sobald eine signierte Version verfügbar ist, wird der Download hier angezeigt. Ihr Web-Arbeitsbereich ist jetzt einsatzbereit.',
    forDevice: 'Für dieses Gerät',
    chooseMac: 'Wählen Sie Apple Silicon oder Intel passend zu Ihrem Mac.',
    installersUnavailable:
      'Installationsprogramme sind noch nicht veröffentlicht. Verfügbare Downloads werden hier angezeigt.',
    nixNote:
      'Anweisungen zur Installation des NixOS-Pakets werden angezeigt, sobald das Quellpaket veröffentlicht wurde.',
    workspaceNote:
      'Die Desktop-App verbindet sich mit diesem Poneva-Arbeitsbereich. Sie erstellt kein separates Konto und kopiert Ihre Chats nicht.',
    checksum: 'Prüfsumme',
    copied: 'Kopiert',
    copyChecksum: 'Prüfsumme kopieren',
    download: 'Herunterladen',
    installer: 'Installationsprogramm',
    invitationLink: 'Zu den Verbindungen',
    googlePendingTitle: 'In Ihrem Browser fortfahren',
    googlePendingLead:
      'Schließen Sie die Anmeldung mit Google in Ihrem Browser ab und wählen Sie anschließend „Poneva Chat öffnen“, um hierher zurückzukehren.',
    googlePendingWaiting: 'Warten auf Anmeldung…',
    googlePendingNote: 'Lassen Sie dieses Fenster geöffnet, während Sie sich anmelden.',
    desktopDescription:
      'Verwenden Sie Poneva in einem Desktopfenster mit demselben Konto, denselben Chats und demselben Unternehmensarbeitsbereich wie in der Web-App.',
    detectedPlatformHint:
      '{platform} erkannt. Sie können Poneva auch für einen anderen Computer herunterladen.',
    choosePlatformHint:
      'Wählen Sie die Plattform für den Computer aus, auf dem Sie Poneva verwenden möchten.',
    downloadFor: 'Für {arch} herunterladen',
    downloadFormat: '{format} herunterladen',
    dmgInstaller: 'DMG-Installer',
    nixUpdateInstruction:
      'Für eine neuere Version ersetzen Sie die Eingabe-URL durch die neue Quell-URL und aktualisieren Sie anschließend Ihre Lock-Datei:',
    sourceVersion: 'Quelle v{version} · SHA-256:',
    nixUnpublished:
      'Anweisungen für das NixOS-Paket werden angezeigt, sobald das Quellpaket veröffentlicht wurde.',
    platformDownloads: 'Downloads für {platform}',
    ponevaFor: 'Poneva für {platform}',
  },
  el: {
    connectionFailed: 'Η σύνδεση δεν ολοκληρώθηκε',
    connectionChecking: 'Έλεγχος σύνδεσης',
    connectionFailedBody:
      'Ο πάροχος δεν μπόρεσε να ολοκληρώσει την εξουσιοδότηση. Επιστρέψτε στο αρχικό παράθυρο του Poneva για λεπτομέρειες και νέα προσπάθεια.',
    connectionCheckingBody:
      'Το αρχικό παράθυρο του Poneva ελέγχει αν ο λογαριασμός συνδέθηκε. Μπορείτε να κλείσετε αυτό το παράθυρο.',
    goConnections: 'Μετάβαση στις συνδέσεις',
    choosePlatform: 'Επιλέξτε πλατφόρμα λήψης',
    forMac: 'Για Mac',
    forPc: 'Για PC',
    includingNix: 'Περιλαμβάνεται το NixOS',
    verify: 'Επαλήθευση λήψης',
    checksumHelp:
      'Συγκρίνετε το checksum του αρχείου με τα υπογεγραμμένα checksum και επαληθεύστε την υπογραφή χρησιμοποιώντας το δημόσιο κλειδί του Poneva.',
    signedChecksums: 'Υπογεγραμμένα checksum',
    signature: 'Υπογραφή',
    publicKey: 'Δημόσιο κλειδί',
    fingerprint: 'Αποτύπωμα δημόσιου κλειδιού (SHA-256):',
    downloads: 'Λήψεις',
    checkingDownloads: 'Έλεγχος διαθέσιμων λήψεων…',
    unavailable: 'Οι λήψεις δεν είναι προσωρινά διαθέσιμες. Δοκιμάστε ξανά.',
    notPublished: 'Οι λήψεις για υπολογιστές δεν έχουν δημοσιευτεί ακόμη.',
    webReady:
      'Όταν είναι διαθέσιμη μια υπογεγραμμένη έκδοση, η λήψη της θα εμφανιστεί εδώ. Ο χώρος εργασίας σας στον ιστό είναι έτοιμος για χρήση τώρα.',
    forDevice: 'Για αυτή τη συσκευή',
    chooseMac: 'Επιλέξτε Apple silicon ή Intel, ανάλογα με το Mac σας.',
    installersUnavailable:
      'Τα προγράμματα εγκατάστασης δεν έχουν δημοσιευτεί ακόμη. Οι διαθέσιμες λήψεις θα εμφανιστούν εδώ.',
    nixNote:
      'Οι οδηγίες εγκατάστασης πακέτων για το NixOS θα εμφανιστούν όταν δημοσιευτεί το πακέτο πηγαίου κώδικα.',
    workspaceNote:
      'Η εφαρμογή υπολογιστή συνδέεται σε αυτόν τον χώρο εργασίας του Poneva· δεν δημιουργεί ξεχωριστό λογαριασμό ούτε αντιγράφει τις συνομιλίες σας.',
    checksum: 'Άθροισμα ελέγχου',
    copied: 'Αντιγράφηκε',
    copyChecksum: 'Αντιγραφή αθροίσματος',
    download: 'Λήψη',
    installer: 'πρόγραμμα εγκατάστασης',
    invitationLink: 'Μετάβαση στις συνδέσεις',
    googlePendingTitle: 'Συνεχίστε στο πρόγραμμα περιήγησής σας',
    googlePendingLead:
      'Ολοκληρώστε τη σύνδεση με Google στο πρόγραμμα περιήγησής σας και, στη συνέχεια, επιλέξτε «Άνοιγμα του Poneva Chat» για να επιστρέψετε εδώ.',
    googlePendingWaiting: 'Αναμονή για σύνδεση…',
    googlePendingNote: 'Διατηρήστε αυτό το παράθυρο ανοιχτό όσο συνδέεστε.',
    desktopDescription:
      'Χρησιμοποιήστε το Poneva σε παράθυρο επιφάνειας εργασίας με τον ίδιο λογαριασμό, τις ίδιες συνομιλίες και τον ίδιο εταιρικό χώρο εργασίας όπως στην εφαρμογή ιστού.',
    detectedPlatformHint:
      'Εντοπίστηκε {platform}. Μπορείτε επίσης να κάνετε λήψη για άλλον υπολογιστή.',
    choosePlatformHint:
      'Επιλέξτε την πλατφόρμα για τον υπολογιστή στον οποίο θέλετε να χρησιμοποιήσετε το Poneva.',
    downloadFor: 'Λήψη για {arch}',
    downloadFormat: 'Λήψη {format}',
    dmgInstaller: 'Πρόγραμμα εγκατάστασης DMG',
    nixUpdateInstruction:
      'Για νεότερη έκδοση, αντικαταστήστε το URL εισόδου με το νέο URL πηγής και, στη συνέχεια, ενημερώστε το αρχείο κλειδώματος:',
    sourceVersion: 'Πηγή v{version} · SHA-256:',
    nixUnpublished: 'Οι οδηγίες πακέτου NixOS θα εμφανιστούν όταν δημοσιευτεί το πακέτο πηγής.',
    platformDownloads: 'Λήψεις για {platform}',
    ponevaFor: 'Poneva για {platform}',
  },
  es: {
    connectionFailed: 'La conexión no se completó',
    connectionChecking: 'Comprobando la conexión',
    connectionFailedBody:
      'El proveedor no pudo completar la autorización. Vuelve a tu ventana original de Poneva para consultar los detalles e intentarlo de nuevo.',
    connectionCheckingBody:
      'Tu ventana original de Poneva está comprobando si la cuenta se conectó. Puedes cerrar esta ventana.',
    goConnections: 'Ir a conexiones',
    choosePlatform: 'Elige una plataforma de descarga',
    forMac: 'Para tu Mac',
    forPc: 'Para tu PC',
    includingNix: 'Incluido NixOS',
    verify: 'Verificar esta descarga',
    checksumHelp:
      'Compara la suma de comprobación del archivo con las sumas firmadas y verifica la firma con la clave pública de Poneva.',
    signedChecksums: 'Sumas de comprobación firmadas',
    signature: 'Firma',
    publicKey: 'Clave pública',
    fingerprint: 'Huella digital de la clave pública (SHA-256):',
    downloads: 'Descargas',
    checkingDownloads: 'Comprobando las descargas disponibles…',
    unavailable: 'Las descargas no están disponibles temporalmente. Inténtalo de nuevo más tarde.',
    notPublished: 'Las descargas de escritorio aún no se han publicado.',
    webReady:
      'Cuando haya una versión firmada disponible, su descarga aparecerá aquí. Tu espacio de trabajo web ya está listo para usarse.',
    forDevice: 'Para este dispositivo',
    chooseMac: 'Elige Apple silicon o Intel según corresponda a tu Mac.',
    installersUnavailable:
      'Los instaladores aún no se han publicado. Las descargas disponibles aparecerán aquí.',
    nixNote:
      'Las instrucciones del paquete de NixOS aparecerán cuando se publique el paquete de origen.',
    workspaceNote:
      'La aplicación de escritorio se conecta a este espacio de trabajo de Poneva; no crea una cuenta aparte ni copia tus chats.',
    checksum: 'Suma de comprobación',
    copied: 'Copiado',
    copyChecksum: 'Copiar suma de comprobación',
    download: 'Descargar',
    installer: 'instalador',
    invitationLink: 'Ir a conexiones',
    googlePendingTitle: 'Continúa en tu navegador',
    googlePendingLead:
      'Termina de iniciar sesión con Google en tu navegador y, después, selecciona Abrir Poneva Chat para volver aquí.',
    googlePendingWaiting: 'Esperando a que inicies sesión…',
    googlePendingNote: 'Mantén esta ventana abierta mientras inicias sesión.',
    desktopDescription:
      'Usa Poneva en una ventana de escritorio con la misma cuenta, chats y espacio de trabajo de la empresa que en la aplicación web.',
    detectedPlatformHint: 'Se detectó {platform}. También puedes descargarlo para otro equipo.',
    choosePlatformHint: 'Elige la plataforma del equipo donde quieres usar Poneva.',
    downloadFor: 'Descargar para {arch}',
    downloadFormat: 'Descargar {format}',
    dmgInstaller: 'Instalador DMG',
    nixUpdateInstruction:
      'Para obtener una versión más reciente, reemplaza la URL de entrada por la nueva URL de origen y, después, actualiza el archivo de bloqueo:',
    sourceVersion: 'Versión de origen v{version} · SHA-256:',
    nixUnpublished:
      'Las instrucciones del paquete de NixOS aparecerán cuando se publique el paquete de origen.',
    platformDownloads: 'Descargas para {platform}',
    ponevaFor: 'Poneva para {platform}',
  },
  et: {
    connectionFailed: 'Ühendust ei lõpetatud',
    connectionChecking: 'Ühenduse kontrollimine',
    connectionFailedBody:
      'Teenusepakkujal ei õnnestunud autoriseerimist lõpule viia. Lisateabe ja uue katse tegemiseks naaske algsesse Poneva aknasse.',
    connectionCheckingBody:
      'Teie algne Poneva aken kontrollib, kas konto ühendati. Võite selle akna sulgeda.',
    goConnections: 'Ava ühendused',
    choosePlatform: 'Vali allalaadimisplatvorm',
    forMac: 'Teie Macile',
    forPc: 'Teie PC-le',
    includingNix: 'Sh NixOS',
    verify: 'Kontrolli seda allalaadimist',
    checksumHelp:
      'Võrrelge faili kontrollsummat allkirjastatud kontrollsummadega ja kontrollige allkirja Poneva avaliku võtme abil.',
    signedChecksums: 'Allkirjastatud kontrollsummad',
    signature: 'Allkiri',
    publicKey: 'Avalik võti',
    fingerprint: 'Avaliku võtme sõrmejälg (SHA-256):',
    downloads: 'Allalaadimised',
    checkingDownloads: 'Saadaolevate allalaadimiste kontrollimine…',
    unavailable: 'Allalaadimised pole ajutiselt saadaval. Proovi hiljem uuesti.',
    notPublished: 'Töölauarakenduse allalaadimisi pole veel avaldatud.',
    webReady:
      'Kui allkirjastatud väljalase on saadaval, kuvatakse selle allalaadimine siin. Teie veebipõhine tööruum on nüüd kasutamiseks valmis.',
    forDevice: 'Selle seadme jaoks',
    chooseMac: 'Valige oma Macile vastavalt Apple silicon või Intel.',
    installersUnavailable:
      'Installiprogramme pole veel avaldatud. Saadaolevad allalaadimised kuvatakse siin.',
    nixNote: 'NixOS-i paketi juhised kuvatakse, kui lähtekoodipakett on avaldatud.',
    workspaceNote:
      'Töölauarakendus loob ühenduse selle Poneva tööruumiga; see ei loo eraldi kontot ega kopeeri teie vestlusi.',
    checksum: 'Kontrollsumma',
    copied: 'Kopeeritud',
    copyChecksum: 'Kopeeri kontrollsumma',
    download: 'Laadi alla',
    installer: 'installiprogramm',
    invitationLink: 'Ava ühendused',
    googlePendingTitle: 'Jätka brauseris',
    googlePendingLead:
      "Lõpeta Google'iga sisselogimine brauseris ja vali seejärel „Ava Poneva Chat“, et siia naasta.",
    googlePendingWaiting: 'Sisselogimise ootamine…',
    googlePendingNote: 'Hoia see aken sisselogimise ajal avatuna.',
    desktopDescription:
      'Kasutage Ponevat töölauaaknas sama konto, vestluste ja ettevõtte tööruumiga nagu veebirakenduses.',
    detectedPlatformHint: 'Tuvastati {platform}. Teise arvuti jaoks saate samuti alla laadida.',
    choosePlatformHint: 'Valige platvorm arvutile, kus soovite Ponevat kasutada.',
    downloadFor: 'Laadi alla platvormile {arch}',
    downloadFormat: 'Laadi alla {format}',
    dmgInstaller: 'DMG-paigaldaja',
    nixUpdateInstruction:
      'Uuema väljalaske jaoks asendage sisendi URL uue lähte-URL-iga ja värskendage lukustusfaili:',
    sourceVersion: 'Lähteversioon v{version} · SHA-256:',
    nixUnpublished: 'NixOS-i paketi juhised kuvatakse, kui lähtepakett avaldatakse.',
    platformDownloads: 'Platvormi {platform} allalaadimised',
    ponevaFor: 'Poneva platvormile {platform}',
  },
  fi: {
    connectionFailed: 'Yhteyttä ei viimeistelty',
    connectionChecking: 'Yhteyttä tarkistetaan',
    connectionFailedBody:
      'Palveluntarjoaja ei voinut suorittaa valtuutusta loppuun. Palaa alkuperäiseen Poneva-ikkunaan saadaksesi lisätietoja ja yrittääksesi uudelleen.',
    connectionCheckingBody:
      'Alkuperäinen Poneva-ikkunasi tarkistaa, yhdistettiinkö tili. Voit sulkea tämän ikkunan.',
    goConnections: 'Siirry yhteyksiin',
    choosePlatform: 'Valitse latausalusta',
    forMac: 'Macille',
    forPc: 'PC:lle',
    includingNix: 'Mukaan lukien NixOS',
    verify: 'Vahvista tämä lataus',
    checksumHelp:
      'Vertaa tiedoston tarkistussummaa allekirjoitettuihin tarkistussummiin ja varmista allekirjoitus Ponevan julkisella avaimella.',
    signedChecksums: 'Allekirjoitetut tarkistussummat',
    signature: 'Allekirjoitus',
    publicKey: 'Julkinen avain',
    fingerprint: 'Julkisen avaimen sormenjälki (SHA-256):',
    downloads: 'Lataukset',
    checkingDownloads: 'Tarkistetaan saatavilla olevia latauksia…',
    unavailable: 'Lataukset eivät ole tällä hetkellä saatavilla. Yritä myöhemmin uudelleen.',
    notPublished: 'Työpöytälatauksia ei ole vielä julkaistu.',
    webReady:
      'Kun allekirjoitettu julkaisu on saatavilla, sen lataus näkyy tässä. Verkko-työtilasi on nyt valmis käytettäväksi.',
    forDevice: 'Tälle laitteelle',
    chooseMac: 'Valitse Apple Silicon tai Intel Macisi mukaan.',
    installersUnavailable:
      'Asennusohjelmia ei ole vielä julkaistu. Saatavilla olevat lataukset näkyvät tässä.',
    nixNote: 'NixOS-paketin ohjeet tulevat näkyviin, kun lähdepaketti on julkaistu.',
    workspaceNote:
      'Työpöytäsovellus muodostaa yhteyden tähän Poneva-työtilaan. Se ei luo erillistä tiliä eikä kopioi keskustelujasi.',
    checksum: 'Tarkistussumma',
    copied: 'Kopioitu',
    copyChecksum: 'Kopioi tarkistussumma',
    download: 'Lataa',
    installer: 'asennusohjelma',
    invitationLink: 'Siirry yhteyksiin',
    googlePendingTitle: 'Jatka selaimessa',
    googlePendingLead:
      'Viimeistele Googleen kirjautuminen selaimessa ja palaa tänne valitsemalla Avaa Poneva Chat.',
    googlePendingWaiting: 'Odotetaan kirjautumista…',
    googlePendingNote: 'Pidä tämä ikkuna avoinna kirjautumisen ajan.',
    desktopDescription:
      'Käytä Ponevaa työpöytäikkunassa samalla tilillä, samoilla keskusteluilla ja samassa yrityksen työtilassa kuin verkkosovelluksessa.',
    detectedPlatformHint:
      'Tunnistettu alusta: {platform}. Voit ladata version myös toiselle tietokoneelle.',
    choosePlatformHint: 'Valitse sen tietokoneen alusta, jolla haluat käyttää Ponevaa.',
    downloadFor: 'Lataa versiolle {arch}',
    downloadFormat: 'Lataa {format}',
    dmgInstaller: 'DMG-asennusohjelma',
    nixUpdateInstruction:
      'Ota uudempi julkaisu käyttöön vaihtamalla inputin URL-osoite uuteen lähde-URL-osoitteeseen ja päivittämällä sitten lukitustiedosto:',
    sourceVersion: 'Lähde v{version} · SHA-256:',
    nixUnpublished: 'NixOS-paketin ohjeet tulevat näkyviin, kun lähdepaketti on julkaistu.',
    platformDownloads: '{platform}-lataukset',
    ponevaFor: 'Poneva – {platform}',
  },
  fr: {
    connectionFailed: 'La connexion n’a pas abouti',
    connectionChecking: 'Vérification de la connexion',
    connectionFailedBody:
      'Le fournisseur n’a pas pu terminer l’autorisation. Revenez à votre fenêtre Poneva d’origine pour voir les détails et réessayer.',
    connectionCheckingBody:
      'Votre fenêtre Poneva d’origine vérifie si le compte a été connecté. Vous pouvez fermer cette fenêtre.',
    goConnections: 'Accéder aux connexions',
    choosePlatform: 'Choisir une plateforme de téléchargement',
    forMac: 'Pour votre Mac',
    forPc: 'Pour votre PC',
    includingNix: 'Y compris NixOS',
    verify: 'Vérifier ce téléchargement',
    checksumHelp:
      'Comparez la somme de contrôle du fichier avec les sommes de contrôle signées et vérifiez la signature à l’aide de la clé publique de Poneva.',
    signedChecksums: 'Sommes de contrôle signées',
    signature: 'Signature',
    publicKey: 'Clé publique',
    fingerprint: 'Empreinte de la clé publique (SHA-256) :',
    downloads: 'Téléchargements',
    checkingDownloads: 'Vérification des téléchargements disponibles…',
    unavailable: 'Les téléchargements sont momentanément indisponibles. Réessayez plus tard.',
    notPublished: 'Les téléchargements de bureau ne sont pas encore publiés.',
    webReady:
      'Lorsqu’une version signée sera disponible, son téléchargement apparaîtra ici. Votre espace de travail web est prêt à être utilisé.',
    forDevice: 'Pour cet appareil',
    chooseMac: 'Choisissez Apple silicon ou Intel selon votre Mac.',
    installersUnavailable:
      'Les programmes d’installation ne sont pas encore publiés. Les téléchargements disponibles apparaîtront ici.',
    nixNote:
      'Les instructions d’installation du paquet NixOS apparaîtront lorsque le paquet source sera publié.',
    workspaceNote:
      'L’application de bureau se connecte à cet espace de travail Poneva ; elle ne crée pas de compte séparé et ne copie pas vos conversations.',
    checksum: 'Somme de contrôle',
    copied: 'Copié',
    copyChecksum: 'Copier la somme de contrôle',
    download: 'Télécharger',
    installer: 'programme d’installation',
    invitationLink: 'Accéder aux connexions',
    googlePendingTitle: 'Continuez dans votre navigateur',
    googlePendingLead:
      'Terminez la connexion avec Google dans votre navigateur, puis sélectionnez « Ouvrir Poneva Chat » pour revenir ici.',
    googlePendingWaiting: 'Connexion en attente…',
    googlePendingNote: 'Gardez cette fenêtre ouverte pendant la connexion.',
    desktopDescription:
      'Utilisez Poneva dans une fenêtre de bureau avec le même compte, les mêmes conversations et le même espace de travail d’entreprise que dans l’application web.',
    detectedPlatformHint:
      '{platform} détecté. Vous pouvez également télécharger Poneva pour un autre ordinateur.',
    choosePlatformHint:
      'Choisissez la plateforme de l’ordinateur sur lequel vous souhaitez utiliser Poneva.',
    downloadFor: 'Télécharger pour {arch}',
    downloadFormat: 'Télécharger {format}',
    dmgInstaller: 'Programme d’installation DMG',
    nixUpdateInstruction:
      'Pour obtenir une version plus récente, remplacez l’URL d’entrée par sa nouvelle URL source, puis mettez à jour votre fichier de verrouillage :',
    sourceVersion: 'Source v{version} · SHA-256 :',
    nixUnpublished:
      'Les instructions d’installation du paquet NixOS apparaîtront lorsque le paquet source sera publié.',
    platformDownloads: 'Téléchargements pour {platform}',
    ponevaFor: 'Poneva pour {platform}',
  },
  ga: {
    connectionFailed: 'Níor críochnaíodh an nasc',
    connectionChecking: 'An nasc á sheiceáil',
    connectionFailedBody:
      'Níor éirigh leis an soláthraí an t-údarú a chríochnú. Fill ar do bhfuinneog bhunaidh Poneva chun sonraí agus triail eile a fháil.',
    connectionCheckingBody:
      'Tá do bhfuinneog bhunaidh Poneva ag seiceáil an bhfuil an cuntas nasctha. Is féidir leat an fhuinneog seo a dhúnadh.',
    goConnections: 'Téigh chuig naisc',
    choosePlatform: 'Roghnaigh ardán íoslódála',
    forMac: 'Do do Mac',
    forPc: 'Do do ríomhaire',
    includingNix: 'NixOS san áireamh',
    verify: 'Deimhnigh an íoslódáil seo',
    checksumHelp:
      'Cuir seiceam an chomhaid i gcomparáid leis na seiceamanna sínithe agus fíoraigh an síniú le heochair phoiblí Poneva.',
    signedChecksums: 'Seiceamanna sínithe',
    signature: 'Síniú',
    publicKey: 'Eochair phoiblí',
    fingerprint: 'Méarlorg na heochrach poiblí (SHA-256):',
    downloads: 'Íoslódálacha',
    checkingDownloads: 'Íoslódálacha ar fáil á seiceáil…',
    unavailable: 'Níl na híoslódálacha ar fáil faoi láthair. Bain triail eile as níos déanaí.',
    notPublished: 'Níor foilsíodh íoslódálacha deisce fós.',
    webReady:
      'Nuair a bheidh eisiúint sínithe ar fáil, beidh a híoslódáil le feiceáil anseo. Tá do spás oibre gréasáin réidh le húsáid anois.',
    forDevice: 'Don ghléas seo',
    chooseMac: 'Roghnaigh Apple silicon nó Intel chun teacht le do Mac.',
    installersUnavailable:
      'Níl suiteálaithe foilsithe fós. Beidh na híoslódálacha atá ar fáil le feiceáil anseo.',
    nixNote:
      'Beidh treoracha phacáiste NixOS le feiceáil nuair a fhoilseofar an pacáiste foinseach.',
    workspaceNote:
      'Nascann an feidhmchlár deisce leis an spás oibre Poneva seo; ní chruthaíonn sé cuntas ar leith ná ní chóipeálann sé do chomhráite.',
    checksum: 'Seiceam',
    copied: 'Cóipeáilte',
    copyChecksum: 'Cóipeáil an seiceam',
    download: 'Íoslódáil',
    installer: 'suiteálaí',
    invitationLink: 'Téigh chuig naisc',
    googlePendingTitle: 'Lean ar aghaidh i do bhrabhsálaí',
    googlePendingLead:
      'Críochnaigh an síniú isteach le Google i do bhrabhsálaí, ansin roghnaigh Oscail Poneva Chat chun filleadh anseo.',
    googlePendingWaiting: 'Ag fanacht le síniú isteach…',
    googlePendingNote: 'Coinnigh an fhuinneog seo ar oscailt agus tú ag síniú isteach.',
    desktopDescription:
      'Úsáid Poneva i bhfuinneog deisce leis an gcuntas, na comhráite agus spás oibre na cuideachta céanna atá san aip ghréasáin.',
    detectedPlatformHint:
      'Braitheadh {platform}. Is féidir leat é a íoslódáil do ríomhaire eile freisin.',
    choosePlatformHint: 'Roghnaigh an t-ardán don ríomhaire ar mian leat Poneva a úsáid air.',
    downloadFor: 'Íoslódáil do {arch}',
    downloadFormat: 'Íoslódáil {format}',
    dmgInstaller: 'Suiteálaí DMG',
    nixUpdateInstruction:
      'Le haghaidh eisiúint níos nuaí, cuir URL nua na foinse in áit an URL ionchuir, ansin nuashonraigh do chomhad glasála:',
    sourceVersion: 'Foinse v{version} · SHA-256:',
    nixUnpublished:
      'Beidh treoracha don phacáiste NixOS ar fáil nuair a fhoilseofar an pacáiste foinse.',
    platformDownloads: 'Íoslódálacha do {platform}',
    ponevaFor: 'Poneva do {platform}',
  },
  hr: {
    connectionFailed: 'Veza nije dovršena',
    connectionChecking: 'Provjera veze',
    connectionFailedBody:
      'Pružatelj nije mogao dovršiti autorizaciju. Vratite se u izvorni prozor Poneve za pojedinosti i ponovni pokušaj.',
    connectionCheckingBody:
      'Vaš izvorni prozor Poneve provjerava je li račun povezan. Možete zatvoriti ovaj prozor.',
    goConnections: 'Idi na veze',
    choosePlatform: 'Odaberite platformu za preuzimanje',
    forMac: 'Za vaš Mac',
    forPc: 'Za vaše PC računalo',
    includingNix: 'Uključujući NixOS',
    verify: 'Provjeri ovo preuzimanje',
    checksumHelp:
      'Usporedite kontrolnu sumu datoteke s potpisanim kontrolnim sumama i provjerite potpis pomoću javnog ključa Poneve.',
    signedChecksums: 'Potpisane kontrolne sume',
    signature: 'Potpis',
    publicKey: 'Javni ključ',
    fingerprint: 'Otisak javnog ključa (SHA-256):',
    downloads: 'Preuzimanja',
    checkingDownloads: 'Provjera dostupnih preuzimanja…',
    unavailable: 'Preuzimanja trenutačno nisu dostupna. Pokušajte ponovno kasnije.',
    notPublished: 'Preuzimanja za računalo još nisu objavljena.',
    webReady:
      'Kada potpisano izdanje bude dostupno, njegovo će se preuzimanje pojaviti ovdje. Vaš web-radni prostor sada je spreman za upotrebu.',
    forDevice: 'Za ovaj uređaj',
    chooseMac: 'Odaberite Apple silicon ili Intel, ovisno o vašem Macu.',
    installersUnavailable:
      'Instalacijski programi još nisu objavljeni. Dostupna preuzimanja pojavit će se ovdje.',
    nixNote: 'Upute za paket NixOS pojavit će se kada izvorni paket bude objavljen.',
    workspaceNote:
      'Aplikacija za računalo povezuje se s ovim radnim prostorom Poneve; ne stvara zaseban račun niti kopira vaše razgovore.',
    checksum: 'Kontrolna suma',
    copied: 'Kopirano',
    copyChecksum: 'Kopiraj kontrolnu sumu',
    download: 'Preuzmi',
    installer: 'instalacijski program',
    invitationLink: 'Idi na veze',
    googlePendingTitle: 'Nastavite u pregledniku',
    googlePendingLead:
      'Dovršite prijavu putem Googlea u pregledniku, a zatim odaberite Otvori Poneva Chat za povratak ovamo.',
    googlePendingWaiting: 'Čeka se prijava…',
    googlePendingNote: 'Ostavite ovaj prozor otvoren tijekom prijave.',
    desktopDescription:
      'Koristite Ponevu u desktop prozoru s istim računom, razgovorima i radnim prostorom tvrtke kao u web-aplikaciji.',
    detectedPlatformHint:
      'Otkriven je sustav {platform}. Možete preuzeti i verziju za drugo računalo.',
    choosePlatformHint: 'Odaberite platformu za računalo na kojem želite koristiti Ponevu.',
    downloadFor: 'Preuzmi za {arch}',
    downloadFormat: 'Preuzmi {format}',
    dmgInstaller: 'DMG instalacijski program',
    nixUpdateInstruction:
      'Za noviju verziju zamijenite URL unosa njegovim novim izvornim URL-om, a zatim ažurirajte datoteku zaključavanja:',
    sourceVersion: 'Izvorna verzija v{version} · SHA-256:',
    nixUnpublished: 'Upute za NixOS paket pojavit će se kada izvorni paket bude objavljen.',
    platformDownloads: 'Preuzimanja za {platform}',
    ponevaFor: 'Poneva za {platform}',
  },
  hu: {
    connectionFailed: 'A kapcsolat nem fejeződött be',
    connectionChecking: 'Kapcsolat ellenőrzése',
    connectionFailedBody:
      'A szolgáltató nem tudta befejezni az engedélyezést. A részletekért és az újrapróbálkozáshoz térj vissza az eredeti Poneva-ablakhoz.',
    connectionCheckingBody:
      'Az eredeti Poneva-ablak ellenőrzi, hogy csatlakozott-e a fiók. Ezt az ablakot bezárhatod.',
    goConnections: 'Ugrás a kapcsolatokhoz',
    choosePlatform: 'Válasszon letöltési platformot',
    forMac: 'Machez',
    forPc: 'PC-hez',
    includingNix: 'A NixOS-t is beleértve',
    verify: 'Letöltés ellenőrzése',
    checksumHelp:
      'Hasonlítsd össze a fájl ellenőrzőösszegét az aláírt ellenőrzőösszegekkel, majd ellenőrizd az aláírást a Poneva nyilvános kulcsával.',
    signedChecksums: 'Aláírt ellenőrzőösszegek',
    signature: 'Aláírás',
    publicKey: 'Nyilvános kulcs',
    fingerprint: 'Nyilvános kulcs ujjlenyomata (SHA-256):',
    downloads: 'Letöltések',
    checkingDownloads: 'Elérhető letöltések ellenőrzése…',
    unavailable: 'A letöltések átmenetileg nem érhetők el. Próbálja később.',
    notPublished: 'Az asztali letöltések még nincsenek közzétéve.',
    webReady:
      'Amikor elérhetővé válik egy aláírt kiadás, a letöltése itt jelenik meg. A webes munkaterületed most már használatra kész.',
    forDevice: 'Ehhez az eszközhöz',
    chooseMac: 'Válaszd az Apple Silicon vagy az Intel verziót a Macednek megfelelően.',
    installersUnavailable:
      'A telepítők még nincsenek közzétéve. Az elérhető letöltések itt jelennek meg.',
    nixNote: 'A NixOS-csomag telepítési útmutatója a forráscsomag közzétételekor jelenik meg.',
    workspaceNote:
      'Az asztali alkalmazás ehhez a Poneva-munkaterülethez csatlakozik; nem hoz létre külön fiókot, és nem másolja át a csevegéseidet.',
    checksum: 'Ellenőrzőösszeg',
    copied: 'Másolva',
    copyChecksum: 'Ellenőrzőösszeg másolása',
    download: 'Letöltés',
    installer: 'telepítő',
    invitationLink: 'Ugrás a kapcsolatokhoz',
    googlePendingTitle: 'Folytatás a böngészőben',
    googlePendingLead:
      'Fejezd be a Google-bejelentkezést a böngészőben, majd válaszd a Poneva Chat megnyitása lehetőséget, hogy visszatérj ide.',
    googlePendingWaiting: 'Várakozás a bejelentkezésre…',
    googlePendingNote: 'Hagyd nyitva ezt az ablakot, amíg bejelentkezel.',
    desktopDescription:
      'Használd a Ponevát asztali ablakban ugyanazzal a fiókkal, csevegésekkel és vállalati munkaterülettel, mint a webalkalmazásban.',
    detectedPlatformHint: 'Észlelt platform: {platform}. Másik számítógéphez is letöltheted.',
    choosePlatformHint:
      'Válaszd ki annak a számítógépnek a platformját, amelyen használni szeretnéd a Ponevát.',
    downloadFor: 'Letöltés ehhez: {arch}',
    downloadFormat: '{format} letöltése',
    dmgInstaller: 'DMG-telepítő',
    nixUpdateInstruction:
      'Újabb kiadáshoz cseréld le a bemeneti URL-t az új forrás URL-jére, majd frissítsd a zárolási fájlt:',
    sourceVersion: 'Forrás v{version} · SHA-256:',
    nixUnpublished:
      'A NixOS-csomag telepítési útmutatója akkor jelenik meg, amikor a forráscsomagot közzéteszik.',
    platformDownloads: '{platform} letöltései',
    ponevaFor: 'Poneva ehhez: {platform}',
  },
  it: {
    connectionFailed: 'La connessione non è stata completata',
    connectionChecking: 'Controllo della connessione',
    connectionFailedBody:
      'Il provider non ha potuto completare l’autorizzazione. Torna alla finestra Poneva originale per i dettagli e per riprovare.',
    connectionCheckingBody:
      'La finestra Poneva originale sta verificando se l’account è stato collegato. Puoi chiudere questa finestra.',
    goConnections: 'Vai alle connessioni',
    choosePlatform: 'Scegli una piattaforma di download',
    forMac: 'Per il tuo Mac',
    forPc: 'Per il tuo PC',
    includingNix: 'Incluso NixOS',
    verify: 'Verifica questo download',
    checksumHelp:
      'Confronta il checksum del file con i checksum firmati e verifica la firma usando la chiave pubblica di Poneva.',
    signedChecksums: 'Checksum firmati',
    signature: 'Firma',
    publicKey: 'Chiave pubblica',
    fingerprint: 'Impronta digitale della chiave pubblica (SHA-256):',
    downloads: 'Download',
    checkingDownloads: 'Controllo dei download disponibili…',
    unavailable: 'I download non sono temporaneamente disponibili. Riprova più tardi.',
    notPublished: 'I download desktop non sono ancora pubblicati.',
    webReady:
      'Quando sarà disponibile una release firmata, il relativo download apparirà qui. Il tuo spazio di lavoro web è pronto per l’uso.',
    forDevice: 'Per questo dispositivo',
    chooseMac: 'Scegli Apple silicon o Intel in base al tuo Mac.',
    installersUnavailable:
      'Gli installer non sono ancora stati pubblicati. I download disponibili appariranno qui.',
    nixNote:
      'Le istruzioni per il pacchetto NixOS appariranno quando il pacchetto sorgente sarà pubblicato.',
    workspaceNote:
      'L’app desktop si connette a questo spazio di lavoro Poneva; non crea un account separato né copia le tue chat.',
    checksum: 'Somma di controllo',
    copied: 'Copiato',
    copyChecksum: 'Copia checksum',
    download: 'Scarica',
    installer: 'programma di installazione',
    invitationLink: 'Vai alle connessioni',
    googlePendingTitle: 'Continua nel browser',
    googlePendingLead:
      "Completa l'accesso con Google nel browser, quindi seleziona Apri Poneva Chat per tornare qui.",
    googlePendingWaiting: "In attesa dell'accesso…",
    googlePendingNote: 'Tieni aperta questa finestra mentre accedi.',
    desktopDescription:
      "Usa Poneva in una finestra desktop con lo stesso account, le stesse chat e lo stesso spazio di lavoro aziendale dell'app web.",
    detectedPlatformHint: 'Rilevato {platform}. Puoi anche scaricare Poneva per un altro computer.',
    choosePlatformHint: 'Scegli la piattaforma del computer su cui vuoi usare Poneva.',
    downloadFor: 'Scarica per {arch}',
    downloadFormat: 'Scarica {format}',
    dmgInstaller: 'Installer DMG',
    nixUpdateInstruction:
      "Per una versione più recente, sostituisci l'URL di input con il nuovo URL della sorgente, quindi aggiorna il file di lock:",
    sourceVersion: 'Sorgente v{version} · SHA-256:',
    nixUnpublished:
      'Le istruzioni per il pacchetto NixOS saranno disponibili quando il pacchetto sorgente sarà pubblicato.',
    platformDownloads: 'Download per {platform}',
    ponevaFor: 'Poneva per {platform}',
  },
  lt: {
    connectionFailed: 'Ryšys nebaigtas',
    connectionChecking: 'Tikrinamas ryšys',
    connectionFailedBody:
      'Teikėjui nepavyko užbaigti autorizavimo. Jei reikia išsamios informacijos ir norite bandyti dar kartą, grįžkite į pradinį Poneva langą.',
    connectionCheckingBody:
      'Pradinis Poneva langas tikrina, ar paskyra prijungta. Šį langą galite uždaryti.',
    goConnections: 'Eiti į ryšius',
    choosePlatform: 'Pasirinkite atsisiuntimo platformą',
    forMac: 'Jūsų „Mac“',
    forPc: 'Jūsų kompiuteriui',
    includingNix: 'Įskaitant „NixOS“',
    verify: 'Patikrinti šį atsisiuntimą',
    checksumHelp:
      'Palyginkite failo kontrolinę sumą su pasirašytomis kontrolinėmis sumomis ir patikrinkite parašą naudodami viešąjį Poneva raktą.',
    signedChecksums: 'Pasirašytos kontrolinės sumos',
    signature: 'Parašas',
    publicKey: 'Viešasis raktas',
    fingerprint: 'Viešojo rakto kontrolinis kodas (SHA-256):',
    downloads: 'Atsisiuntimai',
    checkingDownloads: 'Tikrinami galimi atsisiuntimai…',
    unavailable: 'Atsisiuntimai laikinai nepasiekiami. Bandykite vėliau.',
    notPublished: 'Darbalaukio atsisiuntimai dar nepaskelbti.',
    webReady:
      'Kai bus pasiekiamas pasirašytas leidimas, jo atsisiuntimas bus rodomas čia. Jūsų žiniatinklio darbo sritis jau paruošta naudoti.',
    forDevice: 'Šiam įrenginiui',
    chooseMac: 'Pasirinkite „Apple Silicon“ arba „Intel“ pagal savo „Mac“.',
    installersUnavailable:
      'Diegimo programos dar nepaskelbtos. Kai bus pasiekiami atsisiuntimai, jie bus rodomi čia.',
    nixNote:
      '„NixOS“ paketo diegimo instrukcijos bus rodomos, kai bus paskelbtas šaltinio paketas.',
    workspaceNote:
      'Darbalaukio programa prisijungia prie šios Poneva darbo srities; ji nesukuria atskiros paskyros ir nekopijuoja jūsų pokalbių.',
    checksum: 'Kontrolinė suma',
    copied: 'Nukopijuota',
    copyChecksum: 'Kopijuoti kontrolinę sumą',
    download: 'Atsisiųsti',
    installer: 'diegimo programa',
    invitationLink: 'Eiti į ryšius',
    googlePendingTitle: 'Tęskite naršyklėje',
    googlePendingLead:
      'Užbaikite prisijungimą naudodami „Google“ naršyklėje, tada pasirinkite „Atidaryti Poneva Chat“, kad grįžtumėte čia.',
    googlePendingWaiting: 'Laukiama, kol prisijungsite…',
    googlePendingNote: 'Kol jungiatės, palikite šį langą atidarytą.',
    desktopDescription:
      'Naudokite Poneva darbalaukio lange su ta pačia paskyra, pokalbiais ir įmonės darbo sritimi kaip žiniatinklio programėlėje.',
    detectedPlatformHint:
      'Aptikta platforma: {platform}. Taip pat galite atsisiųsti versiją kitam kompiuteriui.',
    choosePlatformHint: 'Pasirinkite platformą kompiuteriui, kuriame norite naudoti Poneva.',
    downloadFor: 'Atsisiųsti versiją, skirtą {arch}',
    downloadFormat: 'Atsisiųsti {format}',
    dmgInstaller: 'DMG diegimo programa',
    nixUpdateInstruction:
      'Norėdami įdiegti naujesnį leidimą, pakeiskite įvesties URL nauju šaltinio URL, tada atnaujinkite užrakto failą:',
    sourceVersion: 'Šaltinio v{version} · SHA-256:',
    nixUnpublished: 'NixOS paketo instrukcijos bus pateiktos, kai šaltinio paketas bus paskelbtas.',
    platformDownloads: '{platform} atsisiuntimai',
    ponevaFor: 'Poneva, skirta {platform}',
  },
  lv: {
    connectionFailed: 'Savienojums netika pabeigts',
    connectionChecking: 'Savienojuma pārbaude',
    connectionFailedBody:
      'Pakalpojumu sniedzējam neizdevās pabeigt autorizāciju. Lai skatītu detalizētu informāciju un mēģinātu vēlreiz, atgriezieties sākotnējā Poneva logā.',
    connectionCheckingBody:
      'Sākotnējais Poneva logs pārbauda, vai konts ir pievienots. Varat aizvērt šo logu.',
    goConnections: 'Doties uz savienojumiem',
    choosePlatform: 'Izvēlieties lejupielādes platformu',
    forMac: 'Jūsu Mac datoram',
    forPc: 'Jūsu PC',
    includingNix: 'Ieskaitot NixOS',
    verify: 'Pārbaudīt šo lejupielādi',
    checksumHelp:
      'Salīdziniet faila kontrolsummu ar parakstītajām kontrolsummām un pārbaudiet parakstu, izmantojot Poneva publisko atslēgu.',
    signedChecksums: 'Parakstītās kontrolsummas',
    signature: 'Paraksts',
    publicKey: 'Publiskā atslēga',
    fingerprint: 'Publiskās atslēgas pirkstu nospiedums (SHA-256):',
    downloads: 'Lejupielādes',
    checkingDownloads: 'Pieejamo lejupielāžu pārbaude…',
    unavailable: 'Lejupielādes īslaicīgi nav pieejamas. Mēģiniet vēlāk.',
    notPublished: 'Darbvirsmas lejupielādes vēl nav publicētas.',
    webReady:
      'Kad būs pieejams parakstīts laidiens, tā lejupielāde tiks parādīta šeit. Jūsu tīmekļa darbvieta jau ir gatava lietošanai.',
    forDevice: 'Šai ierīcei',
    chooseMac: 'Izvēlieties Apple silicon vai Intel atbilstoši savam Mac datoram.',
    installersUnavailable:
      'Instalētāji vēl nav publicēti. Pieejamās lejupielādes tiks parādītas šeit.',
    nixNote:
      'NixOS pakotnes instalēšanas norādījumi tiks parādīti, kad būs publicēta avota pakotne.',
    workspaceNote:
      'Darbvirsmas lietotne izveido savienojumu ar šo Poneva darbvietu; tā neizveido atsevišķu kontu un nekopē jūsu tērzēšanas sarunas.',
    checksum: 'Kontrolsumma',
    copied: 'Nokopēts',
    copyChecksum: 'Kopēt kontrolsummu',
    download: 'Lejupielādēt',
    installer: 'instalētājs',
    invitationLink: 'Doties uz savienojumiem',
    googlePendingTitle: 'Turpiniet pārlūkprogrammā',
    googlePendingLead:
      'Pabeidziet pierakstīšanos Google kontā pārlūkprogrammā un pēc tam izvēlieties “Atvērt Poneva Chat”, lai atgrieztos šeit.',
    googlePendingWaiting: 'Gaida pierakstīšanos…',
    googlePendingNote: 'Atstājiet šo logu atvērtu, kamēr pierakstāties.',
    desktopDescription:
      'Izmantojiet Poneva darbvirsmas logā ar to pašu kontu, tērzēšanām un uzņēmuma darbvietu, ko tīmekļa lietotnē.',
    detectedPlatformHint: 'Noteikta platforma: {platform}. Varat lejupielādēt arī citam datoram.',
    choosePlatformHint: 'Izvēlieties platformu datoram, kurā vēlaties izmantot Poneva.',
    downloadFor: 'Lejupielādēt platformai {arch}',
    downloadFormat: 'Lejupielādēt {format}',
    dmgInstaller: 'DMG instalētājs',
    nixUpdateInstruction:
      'Lai izmantotu jaunāku laidienu, aizstājiet ievades URL ar jauno avota URL un pēc tam atjauniniet bloķēšanas failu:',
    sourceVersion: 'Avots v{version} · SHA-256:',
    nixUnpublished: 'NixOS pakotnes norādījumi būs pieejami, kad avota pakotne tiks publicēta.',
    platformDownloads: '{platform} lejupielādes',
    ponevaFor: 'Poneva platformai {platform}',
  },
  mt: {
    connectionFailed: 'Il-konnessjoni ma tlestietx',
    connectionChecking: 'Qed niċċekkjaw il-konnessjoni',
    connectionFailedBody:
      'Il-fornitur ma setax ilesti l-awtorizzazzjoni. Erġa’ lura għat-tieqa oriġinali ta’ Poneva għal aktar dettalji u biex terġa’ tipprova.',
    connectionCheckingBody:
      'It-tieqa oriġinali ta’ Poneva qed tivverifika jekk il-kont kienx ikkonnettjat. Tista’ tagħlaq din it-tieqa.',
    goConnections: 'Mur għall-konnessjonijiet',
    choosePlatform: 'Agħżel pjattaforma tat-tniżżil',
    forMac: 'Għall-Mac tiegħek',
    forPc: 'Għall-PC tiegħek',
    includingNix: 'Inkluż NixOS',
    verify: 'Ivverifika dan it-tniżżil',
    checksumHelp:
      'Qabbel il-checksum tal-fajl mal-checksums iffirmati u vverifika l-firma billi tuża ċ-ċavetta pubblika ta’ Poneva.',
    signedChecksums: 'Checksums iffirmati',
    signature: 'Firma',
    publicKey: 'Ċavetta pubblika',
    fingerprint: 'Marka tas-swaba’ taċ-ċavetta pubblika (SHA-256):',
    downloads: 'Tniżżiliet',
    checkingDownloads: 'Qed niċċekkjaw it-tniżżiliet disponibbli…',
    unavailable: 'It-tniżżiliet mhumiex disponibbli temporanjament. Erġa’ pprova aktar tard.',
    notPublished: 'It-tniżżiliet tad-desktop għadhom ma ġewx ippubblikati.',
    webReady:
      'Meta jkun disponibbli rilaxx iffirmat, it-tniżżil tiegħu jidher hawn. L-ispazju tax-xogħol tal-web tiegħek issa lest biex jintuża.',
    forDevice: 'Għal dan l-apparat',
    chooseMac: 'Agħżel Apple silicon jew Intel skont il-Mac tiegħek.',
    installersUnavailable:
      'L-installaturi għadhom ma ġewx ippubblikati. It-tniżżil disponibbli jidher hawn.',
    nixNote:
      'L-istruzzjonijiet għall-pakkett ta’ NixOS jidhru meta l-pakkett tas-sors jiġi ppubblikat.',
    workspaceNote:
      'L-app tad-desktop tikkonnettja ma’ dan l-ispazju tax-xogħol ta’ Poneva; ma toħloqx kont separat u lanqas tikkopja ċ-chats tiegħek.',
    checksum: "Somma ta' kontroll",
    copied: 'Ikkupjat',
    copyChecksum: 'Ikkopja checksum',
    download: 'Niżżel',
    installer: 'installatur',
    invitationLink: 'Mur għall-konnessjonijiet',
    googlePendingTitle: 'Kompli fil-browser tiegħek',
    googlePendingLead:
      "Imla d-dħul b'Google fil-browser tiegħek, imbagħad agħżel “Iftaħ Poneva Chat” biex terġa' lura hawn.",
    googlePendingWaiting: 'Qed nistennew li tidħol…',
    googlePendingNote: 'Żomm din it-tieqa miftuħa waqt li tidħol.',
    desktopDescription:
      'Uża Poneva f’tieqa tad-desktop bl-istess kont, chats u spazju tax-xogħol tal-kumpanija bħall-app tal-web.',
    detectedPlatformHint: 'Instab {platform}. Tista’ wkoll tniżżel għal kompjuter ieħor.',
    choosePlatformHint: 'Agħżel il-pjattaforma għall-kompjuter fejn trid tuża Poneva.',
    downloadFor: 'Niżżel għal {arch}',
    downloadFormat: 'Niżżel {format}',
    dmgInstaller: 'Installatur DMG',
    nixUpdateInstruction:
      'Għal verżjoni aktar ġdida, ibdel il-URL tal-input bil-URL tas-sors il-ġdid tiegħu, imbagħad aġġorna l-lock file tiegħek:',
    sourceVersion: 'Sors v{version} · SHA-256:',
    nixUnpublished:
      'L-istruzzjonijiet tal-pakkett għal NixOS se jidhru meta l-pakkett tas-sors jiġi ppubblikat.',
    platformDownloads: 'Tniżżiliet ta’ {platform}',
    ponevaFor: 'Poneva għal {platform}',
  },
  nl: {
    connectionFailed: 'Verbinding is niet voltooid',
    connectionChecking: 'Verbinding controleren',
    connectionFailedBody:
      'De provider kon de autorisatie niet voltooien. Ga terug naar je oorspronkelijke Poneva-venster voor meer informatie en om het opnieuw te proberen.',
    connectionCheckingBody:
      'Je oorspronkelijke Poneva-venster controleert of het account is verbonden. Je kunt dit venster sluiten.',
    goConnections: 'Naar verbindingen',
    choosePlatform: 'Kies een downloadplatform',
    forMac: 'Voor je Mac',
    forPc: 'Voor je pc',
    includingNix: 'Inclusief NixOS',
    verify: 'Deze download controleren',
    checksumHelp:
      'Vergelijk de checksum van het bestand met de ondertekende checksums en verifieer de handtekening met de openbare sleutel van Poneva.',
    signedChecksums: 'Ondertekende checksums',
    signature: 'Handtekening',
    publicKey: 'Openbare sleutel',
    fingerprint: 'Vingerafdruk van de openbare sleutel (SHA-256):',
    downloads: 'Downloads',
    checkingDownloads: 'Beschikbare downloads controleren…',
    unavailable: 'Downloads zijn tijdelijk niet beschikbaar. Probeer het later opnieuw.',
    notPublished: 'Desktopdownloads zijn nog niet gepubliceerd.',
    webReady:
      'Wanneer er een ondertekende release beschikbaar is, verschijnt de download hier. Je webwerkruimte is nu klaar voor gebruik.',
    forDevice: 'Voor dit apparaat',
    chooseMac: 'Kies Apple silicon of Intel, afhankelijk van je Mac.',
    installersUnavailable:
      "Installatieprogramma's zijn nog niet gepubliceerd. Beschikbare downloads verschijnen hier.",
    nixNote: 'Instructies voor het NixOS-pakket verschijnen zodra het bronpakket is gepubliceerd.',
    workspaceNote:
      'De desktopapp maakt verbinding met deze Poneva-werkruimte; er wordt geen apart account aangemaakt en je chats worden niet gekopieerd.',
    checksum: 'Controlesom',
    copied: 'Gekopieerd',
    copyChecksum: 'Controlesom kopiëren',
    download: 'Downloaden',
    installer: 'installatieprogramma',
    invitationLink: 'Naar verbindingen',
    googlePendingTitle: 'Ga verder in je browser',
    googlePendingLead:
      'Voltooi het inloggen bij Google in je browser en kies vervolgens Poneva Chat openen om hier terug te keren.',
    googlePendingWaiting: 'Wachten op inloggen…',
    googlePendingNote: 'Houd dit venster open terwijl je inlogt.',
    desktopDescription:
      'Gebruik Poneva in een desktopvenster met hetzelfde account, dezelfde chats en dezelfde bedrijfsworkspace als in de webapp.',
    detectedPlatformHint:
      '{platform} gedetecteerd. Je kunt ook voor een andere computer downloaden.',
    choosePlatformHint: 'Kies het platform voor de computer waarop je Poneva wilt gebruiken.',
    downloadFor: 'Downloaden voor {arch}',
    downloadFormat: '{format} downloaden',
    dmgInstaller: 'DMG-installatieprogramma',
    nixUpdateInstruction:
      'Vervang voor een nieuwere release de invoer-URL door de nieuwe bron-URL en werk vervolgens je lockbestand bij:',
    sourceVersion: 'Bron v{version} · SHA-256:',
    nixUnpublished:
      'Instructies voor het NixOS-pakket verschijnen zodra het bronpakket is gepubliceerd.',
    platformDownloads: 'Downloads voor {platform}',
    ponevaFor: 'Poneva voor {platform}',
  },
  pl: {
    connectionFailed: 'Połączenie nie zostało ukończone',
    connectionChecking: 'Sprawdzanie połączenia',
    connectionFailedBody:
      'Dostawca nie mógł ukończyć autoryzacji. Wróć do pierwotnego okna Poneva, aby zobaczyć szczegóły i spróbować ponownie.',
    connectionCheckingBody:
      'Pierwotne okno Poneva sprawdza, czy konto zostało połączone. Możesz zamknąć to okno.',
    goConnections: 'Przejdź do połączeń',
    choosePlatform: 'Wybierz platformę pobierania',
    forMac: 'Dla komputera Mac',
    forPc: 'Dla komputera PC',
    includingNix: 'W tym NixOS',
    verify: 'Zweryfikuj pobieranie',
    checksumHelp:
      'Porównaj sumę kontrolną pliku z podpisanymi sumami kontrolnymi i zweryfikuj podpis za pomocą klucza publicznego Poneva.',
    signedChecksums: 'Podpisane sumy kontrolne',
    signature: 'Podpis',
    publicKey: 'Klucz publiczny',
    fingerprint: 'Odcisk klucza publicznego (SHA-256):',
    downloads: 'Pobrane',
    checkingDownloads: 'Sprawdzanie dostępnych pobrań…',
    unavailable: 'Pobieranie jest chwilowo niedostępne. Spróbuj ponownie później.',
    notPublished: 'Pobrania na komputer nie są jeszcze opublikowane.',
    webReady:
      'Gdy będzie dostępne podpisane wydanie, jego pobieranie pojawi się tutaj. Twoja przestrzeń robocza w przeglądarce jest już gotowa do użycia.',
    forDevice: 'Dla tego urządzenia',
    chooseMac: 'Wybierz Apple Silicon lub Intel, odpowiednio do swojego komputera Mac.',
    installersUnavailable:
      'Instalatory nie zostały jeszcze opublikowane. Dostępne pliki do pobrania pojawią się tutaj.',
    nixNote: 'Instrukcje dotyczące pakietu NixOS pojawią się po opublikowaniu pakietu źródłowego.',
    workspaceNote:
      'Aplikacja komputerowa łączy się z tą przestrzenią roboczą Poneva — nie tworzy osobnego konta ani nie kopiuje Twoich czatów.',
    checksum: 'Suma kontrolna',
    copied: 'Skopiowano',
    copyChecksum: 'Kopiuj sumę kontrolną',
    download: 'Pobierz',
    installer: 'instalator',
    invitationLink: 'Przejdź do połączeń',
    googlePendingTitle: 'Kontynuuj w przeglądarce',
    googlePendingLead:
      'Dokończ logowanie przez Google w przeglądarce, a następnie wybierz „Otwórz Poneva Chat”, aby tu wrócić.',
    googlePendingWaiting: 'Oczekiwanie na zalogowanie…',
    googlePendingNote: 'Pozostaw to okno otwarte podczas logowania.',
    desktopDescription:
      'Korzystaj z Poneva w oknie aplikacji komputerowej, używając tego samego konta, czatów i firmowego obszaru roboczego co w aplikacji webowej.',
    detectedPlatformHint: 'Wykryto {platform}. Możesz też pobrać wersję na inny komputer.',
    choosePlatformHint: 'Wybierz platformę komputera, na którym chcesz korzystać z Poneva.',
    downloadFor: 'Pobierz dla {arch}',
    downloadFormat: 'Pobierz {format}',
    dmgInstaller: 'Instalator DMG',
    nixUpdateInstruction:
      'W przypadku nowszego wydania zastąp wejściowy adres URL jego nowym źródłowym adresem URL, a następnie zaktualizuj plik blokady:',
    sourceVersion: 'Wersja źródłowa v{version} · SHA-256:',
    nixUnpublished:
      'Instrukcje dotyczące pakietu NixOS pojawią się po opublikowaniu pakietu źródłowego.',
    platformDownloads: 'Pobieranie dla {platform}',
    ponevaFor: 'Poneva dla {platform}',
  },
  pt: {
    connectionFailed: 'A ligação não foi concluída',
    connectionChecking: 'A verificar a ligação',
    connectionFailedBody:
      'O provedor não conseguiu concluir a autorização. Volte à janela original do Poneva para ver os detalhes e tentar novamente.',
    connectionCheckingBody:
      'A janela original do Poneva está verificando se a conta foi conectada. Você pode fechar esta janela.',
    goConnections: 'Ir para ligações',
    choosePlatform: 'Escolha uma plataforma de transferência',
    forMac: 'Para seu Mac',
    forPc: 'Para seu PC',
    includingNix: 'Incluindo o NixOS',
    verify: 'Verificar esta transferência',
    checksumHelp:
      'Compare a soma de verificação do arquivo com as somas de verificação assinadas e verifique a assinatura usando a chave pública do Poneva.',
    signedChecksums: 'Somas de verificação assinadas',
    signature: 'Assinatura',
    publicKey: 'Chave pública',
    fingerprint: 'Impressão digital da chave pública (SHA-256):',
    downloads: 'Transferências',
    checkingDownloads: 'A verificar transferências disponíveis…',
    unavailable: 'As transferências estão temporariamente indisponíveis. Tente mais tarde.',
    notPublished: 'As transferências para computador ainda não foram publicadas.',
    webReady:
      'Quando uma versão assinada estiver disponível, o download aparecerá aqui. Seu espaço de trabalho na web já está pronto para uso.',
    forDevice: 'Para este dispositivo',
    chooseMac: 'Escolha Apple silicon ou Intel de acordo com seu Mac.',
    installersUnavailable:
      'Os instaladores ainda não foram publicados. Os downloads disponíveis aparecerão aqui.',
    nixNote: 'As instruções do pacote do NixOS aparecerão quando o pacote-fonte for publicado.',
    workspaceNote:
      'O aplicativo para desktop se conecta a este espaço de trabalho do Poneva; ele não cria uma conta separada nem copia suas conversas.',
    checksum: 'Soma de verificação',
    copied: 'Copiado',
    copyChecksum: 'Copiar soma de verificação',
    download: 'Baixar',
    installer: 'instalador',
    invitationLink: 'Ir para ligações',
    googlePendingTitle: 'Continuar no navegador',
    googlePendingLead:
      'Termine de iniciar sessão com o Google no navegador e, em seguida, selecione Abrir o Poneva Chat para voltar aqui.',
    googlePendingWaiting: 'A aguardar início de sessão…',
    googlePendingNote: 'Mantenha esta janela aberta enquanto inicia sessão.',
    desktopDescription:
      'Use o Poneva em uma janela da área de trabalho com a mesma conta, conversas e espaço de trabalho da empresa que no app web.',
    detectedPlatformHint:
      'Detectamos {platform}. Você também pode fazer o download para outro computador.',
    choosePlatformHint: 'Escolha a plataforma do computador em que você quer usar o Poneva.',
    downloadFor: 'Baixar para {arch}',
    downloadFormat: 'Baixar {format}',
    dmgInstaller: 'Instalador DMG',
    nixUpdateInstruction:
      'Para obter uma versão mais recente, substitua a URL de entrada pela nova URL de origem e atualize seu arquivo de lock:',
    sourceVersion: 'Origem v{version} · SHA-256:',
    nixUnpublished:
      'As instruções do pacote NixOS aparecerão quando o pacote de origem for publicado.',
    platformDownloads: 'Downloads para {platform}',
    ponevaFor: 'Poneva para {platform}',
  },
  ro: {
    connectionFailed: 'Conexiunea nu a fost finalizată',
    connectionChecking: 'Se verifică conexiunea',
    connectionFailedBody:
      'Furnizorul nu a putut finaliza autorizarea. Revino la fereastra Poneva inițială pentru detalii și pentru a încerca din nou.',
    connectionCheckingBody:
      'Fereastra Poneva inițială verifică dacă acest cont a fost conectat. Poți închide această fereastră.',
    goConnections: 'Mergi la conexiuni',
    choosePlatform: 'Alege platforma de descărcare',
    forMac: 'Pentru Mac-ul tău',
    forPc: 'Pentru PC-ul tău',
    includingNix: 'Inclusiv NixOS',
    verify: 'Verifică această descărcare',
    checksumHelp:
      'Compară suma de control a fișierului cu sumele de control semnate și verifică semnătura folosind cheia publică Poneva.',
    signedChecksums: 'Sume de control semnate',
    signature: 'Semnătură',
    publicKey: 'Cheie publică',
    fingerprint: 'Amprenta cheii publice (SHA-256):',
    downloads: 'Descărcări',
    checkingDownloads: 'Se verifică descărcările disponibile…',
    unavailable: 'Descărcările nu sunt disponibile temporar. Încearcă mai târziu.',
    notPublished: 'Descărcările pentru desktop nu sunt publicate încă.',
    webReady:
      'Când este disponibilă o versiune semnată, descărcarea acesteia va apărea aici. Spațiul de lucru web este gata de utilizare acum.',
    forDevice: 'Pentru acest dispozitiv',
    chooseMac: 'Alege Apple silicon sau Intel pentru a corespunde modelului tău de Mac.',
    installersUnavailable:
      'Programele de instalare nu au fost publicate încă. Descărcările disponibile vor apărea aici.',
    nixNote: 'Instrucțiunile pentru pachetul NixOS vor apărea când pachetul sursă va fi publicat.',
    workspaceNote:
      'Aplicația desktop se conectează la acest spațiu de lucru Poneva; nu creează un cont separat și nu copiază conversațiile.',
    checksum: 'Sumă de control',
    copied: 'Copiat',
    copyChecksum: 'Copiază suma de control',
    download: 'Descarcă',
    installer: 'program de instalare',
    invitationLink: 'Mergi la conexiuni',
    googlePendingTitle: 'Continuă în browser',
    googlePendingLead:
      'Finalizează conectarea cu Google în browser, apoi selectează „Deschide Poneva Chat” pentru a reveni aici.',
    googlePendingWaiting: 'Se așteaptă conectarea…',
    googlePendingNote: 'Păstrează această fereastră deschisă cât timp te conectezi.',
    desktopDescription:
      'Folosește Poneva într-o fereastră desktop, cu același cont, aceleași conversații și același spațiu de lucru al companiei ca în aplicația web.',
    detectedPlatformHint:
      'Platformă detectată: {platform}. Poți descărca și pentru un alt computer.',
    choosePlatformHint: 'Alege platforma pentru computerul pe care vrei să folosești Poneva.',
    downloadFor: 'Descarcă pentru {arch}',
    downloadFormat: 'Descarcă {format}',
    dmgInstaller: 'Instalator DMG',
    nixUpdateInstruction:
      'Pentru o versiune mai nouă, înlocuiește URL-ul de intrare cu noul URL sursă, apoi actualizează fișierul lock:',
    sourceVersion: 'Sursa v{version} · SHA-256:',
    nixUnpublished:
      'Instrucțiunile pentru pachetul NixOS vor apărea când pachetul sursă va fi publicat.',
    platformDownloads: 'Descărcări pentru {platform}',
    ponevaFor: 'Poneva pentru {platform}',
  },
  sk: {
    connectionFailed: 'Pripojenie nebolo dokončené',
    connectionChecking: 'Kontrola pripojenia',
    connectionFailedBody:
      'Poskytovateľ nedokázal dokončiť autorizáciu. Vráťte sa do pôvodného okna Poneva, kde nájdete podrobnosti a môžete skúsiť znova.',
    connectionCheckingBody:
      'V pôvodnom okne Poneva sa kontroluje, či bol účet pripojený. Toto okno môžete zavrieť.',
    goConnections: 'Prejsť na pripojenia',
    choosePlatform: 'Vyberte platformu na stiahnutie',
    forMac: 'Pre Mac',
    forPc: 'Pre PC',
    includingNix: 'Vrátane NixOS',
    verify: 'Overiť toto stiahnutie',
    checksumHelp:
      'Porovnajte kontrolný súčet súboru s podpísanými kontrolnými súčtami a overte podpis pomocou verejného kľúča Poneva.',
    signedChecksums: 'Podpísané kontrolné súčty',
    signature: 'Podpis',
    publicKey: 'Verejný kľúč',
    fingerprint: 'Odtlačok verejného kľúča (SHA-256):',
    downloads: 'Stiahnuté',
    checkingDownloads: 'Kontrolujú sa dostupné stiahnutia…',
    unavailable: 'Stiahnutia sú dočasne nedostupné. Skúste to neskôr.',
    notPublished: 'Stiahnutia pre počítač ešte nie sú zverejnené.',
    webReady:
      'Keď bude k dispozícii podpísané vydanie, jeho stiahnutie sa zobrazí tu. Váš webový pracovný priestor je už pripravený na používanie.',
    forDevice: 'Pre toto zariadenie',
    chooseMac: 'Vyberte Apple silicon alebo Intel podľa svojho Macu.',
    installersUnavailable:
      'Inštalátory zatiaľ neboli zverejnené. Dostupné stiahnutia sa zobrazia tu.',
    nixNote: 'Pokyny na inštaláciu balíka pre NixOS sa zobrazia po zverejnení zdrojového balíka.',
    workspaceNote:
      'Počítačová aplikácia sa pripája k tomuto pracovnému priestoru Poneva; nevytvára samostatný účet ani nekopíruje vaše chaty.',
    checksum: 'Kontrolný súčet',
    copied: 'Skopírované',
    copyChecksum: 'Kopírovať kontrolný súčet',
    download: 'Stiahnuť',
    installer: 'inštalátor',
    invitationLink: 'Prejsť na pripojenia',
    googlePendingTitle: 'Pokračujte v prehliadači',
    googlePendingLead:
      'Dokončite prihlásenie pomocou Googlu v prehliadači a potom vyberte možnosť Otvoriť Poneva Chat, aby ste sa vrátili sem.',
    googlePendingWaiting: 'Čaká sa na prihlásenie…',
    googlePendingNote: 'Počas prihlasovania nechajte toto okno otvorené.',
    desktopDescription:
      'Používajte Poneva v okne pracovnej plochy s rovnakým účtom, chatmi a firemným pracovným priestorom ako vo webovej aplikácii.',
    detectedPlatformHint:
      'Rozpoznaná platforma: {platform}. Môžete si stiahnuť verziu aj pre iný počítač.',
    choosePlatformHint: 'Vyberte platformu počítača, na ktorom chcete používať Poneva.',
    downloadFor: 'Stiahnuť pre {arch}',
    downloadFormat: 'Stiahnuť {format}',
    dmgInstaller: 'Inštalátor DMG',
    nixUpdateInstruction:
      'Ak chcete novšiu verziu, nahraďte vstupnú URL jej novou zdrojovou URL a potom aktualizujte zamykací súbor:',
    sourceVersion: 'Zdrojová verzia v{version} · SHA-256:',
    nixUnpublished:
      'Pokyny na inštaláciu balíka pre NixOS sa zobrazia po publikovaní zdrojového balíka.',
    platformDownloads: 'Stiahnutia pre {platform}',
    ponevaFor: 'Poneva pre {platform}',
  },
  sl: {
    connectionFailed: 'Povezava ni bila dokončana',
    connectionChecking: 'Preverjanje povezave',
    connectionFailedBody:
      'Ponudnik ni mogel dokončati avtorizacije. Za podrobnosti in ponovni poskus se vrnite v prvotno okno Poneva.',
    connectionCheckingBody:
      'V prvotnem oknu Poneva preverjamo, ali je bil račun povezan. To okno lahko zaprete.',
    goConnections: 'Pojdi na povezave',
    choosePlatform: 'Izberite platformo za prenos',
    forMac: 'Za Mac',
    forPc: 'Za PC',
    includingNix: 'Vključno z NixOS',
    verify: 'Preveri ta prenos',
    checksumHelp:
      'Primerjajte kontrolno vsoto datoteke s podpisanimi kontrolnimi vsotami in preverite podpis z javnim ključem Poneva.',
    signedChecksums: 'Podpisane kontrolne vsote',
    signature: 'Podpis',
    publicKey: 'Javni ključ',
    fingerprint: 'Prstni odtis javnega ključa (SHA-256):',
    downloads: 'Prenosi',
    checkingDownloads: 'Preverjanje razpoložljivih prenosov…',
    unavailable: 'Prenosi trenutno niso na voljo. Poskusite pozneje.',
    notPublished: 'Prenosi za namizje še niso objavljeni.',
    webReady:
      'Ko bo na voljo podpisana izdaja, bo njen prenos prikazan tukaj. Vaš spletni delovni prostor je že pripravljen za uporabo.',
    forDevice: 'Za to napravo',
    chooseMac: 'Izberite Apple silicon ali Intel glede na svoj Mac.',
    installersUnavailable:
      'Namestitveni programi še niso objavljeni. Razpoložljivi prenosi bodo prikazani tukaj.',
    nixNote: 'Navodila za paket NixOS bodo prikazana, ko bo izvorni paket objavljen.',
    workspaceNote:
      'Namizna aplikacija se poveže s tem delovnim prostorom Poneva; ne ustvari ločenega računa in ne kopira vaših klepetov.',
    checksum: 'Kontrolna vsota',
    copied: 'Kopirano',
    copyChecksum: 'Kopiraj kontrolno vsoto',
    download: 'Prenos',
    installer: 'namestitveni program',
    invitationLink: 'Pojdi na povezave',
    googlePendingTitle: 'Nadaljujte v brskalniku',
    googlePendingLead:
      'V brskalniku dokončajte prijavo z Googlom, nato izberite »Odpri Poneva Chat«, da se vrnete sem.',
    googlePendingWaiting: 'Čakanje na prijavo…',
    googlePendingNote: 'Med prijavo naj bo to okno odprto.',
    desktopDescription:
      'Uporabljajte Ponevo v namiznem oknu z istim računom, klepeti in delovnim prostorom podjetja kot v spletni aplikaciji.',
    detectedPlatformHint:
      'Zaznana platforma: {platform}. Prenesete jo lahko tudi za drug računalnik.',
    choosePlatformHint: 'Izberite platformo za računalnik, v katerem želite uporabljati Ponevo.',
    downloadFor: 'Prenesi za {arch}',
    downloadFormat: 'Prenesi {format}',
    dmgInstaller: 'Namestitveni program DMG',
    nixUpdateInstruction:
      'Za novejšo izdajo zamenjajte vhodni URL z novim izvornim URL-jem in nato posodobite zaklenjeno datoteko:',
    sourceVersion: 'Izvorna koda v{version} · SHA-256:',
    nixUnpublished: 'Navodila za paket NixOS bodo prikazana, ko bo izvorni paket objavljen.',
    platformDownloads: 'Prenosi za {platform}',
    ponevaFor: 'Poneva za {platform}',
  },
  sv: {
    connectionFailed: 'Anslutningen slutfördes inte',
    connectionChecking: 'Kontrollerar anslutningen',
    connectionFailedBody:
      'Leverantören kunde inte slutföra auktoriseringen. Gå tillbaka till ditt ursprungliga Poneva-fönster för mer information och försök igen.',
    connectionCheckingBody:
      'Ditt ursprungliga Poneva-fönster kontrollerar om kontot anslöts. Du kan stänga det här fönstret.',
    goConnections: 'Gå till anslutningar',
    choosePlatform: 'Välj nedladdningsplattform',
    forMac: 'För din Mac',
    forPc: 'För din PC',
    includingNix: 'Inklusive NixOS',
    verify: 'Verifiera denna nedladdning',
    checksumHelp:
      'Jämför filens kontrollsumma med de signerade kontrollsummorna och verifiera signaturen med Ponevas publika nyckel.',
    signedChecksums: 'Signerade kontrollsummor',
    signature: 'Signatur',
    publicKey: 'Publik nyckel',
    fingerprint: 'Publika nyckelns fingeravtryck (SHA-256):',
    downloads: 'Nedladdningar',
    checkingDownloads: 'Kontrollerar tillgängliga nedladdningar…',
    unavailable: 'Nedladdningar är tillfälligt otillgängliga. Försök igen senare.',
    notPublished: 'Skrivbordsnedladdningar har inte publicerats än.',
    webReady:
      'När en signerad version finns tillgänglig visas nedladdningen här. Din webbarbetsyta är redo att användas nu.',
    forDevice: 'För den här enheten',
    chooseMac: 'Välj Apple silicon eller Intel så att det passar din Mac.',
    installersUnavailable:
      'Installationsprogram har inte publicerats ännu. Tillgängliga nedladdningar visas här.',
    nixNote: 'Instruktioner för NixOS-paket visas när källpaketet har publicerats.',
    workspaceNote:
      'Skrivbordsappen ansluter till den här Poneva-arbetsytan. Den skapar inte ett separat konto och kopierar inte dina chattar.',
    checksum: 'Kontrollsumma',
    copied: 'Kopierad',
    copyChecksum: 'Kopiera kontrollsumma',
    download: 'Ladda ner',
    installer: 'installationsprogram',
    invitationLink: 'Gå till anslutningar',
    googlePendingTitle: 'Fortsätt i webbläsaren',
    googlePendingLead:
      'Slutför inloggningen med Google i webbläsaren och välj sedan Öppna Poneva Chat för att återvända hit.',
    googlePendingWaiting: 'Väntar på inloggning…',
    googlePendingNote: 'Låt det här fönstret vara öppet medan du loggar in.',
    desktopDescription:
      'Använd Poneva i ett skrivbordsfönster med samma konto, chattar och företagsarbetsyta som i webbappen.',
    detectedPlatformHint: '{platform} identifierades. Du kan också ladda ner för en annan dator.',
    choosePlatformHint: 'Välj plattform för den dator där du vill använda Poneva.',
    downloadFor: 'Ladda ner för {arch}',
    downloadFormat: 'Ladda ner {format}',
    dmgInstaller: 'DMG-installationsprogram',
    nixUpdateInstruction:
      'För en nyare version ersätter du indata-URL:en med den nya käll-URL:en och uppdaterar sedan din låsfil:',
    sourceVersion: 'Källversion v{version} · SHA-256:',
    nixUnpublished: 'Instruktioner för NixOS-paket visas när källpaketet har publicerats.',
    platformDownloads: 'Nedladdningar för {platform}',
    ponevaFor: 'Poneva för {platform}',
  },
} as const;

export default entrySurfaceCopy;
